<div (window:resize)="onWindowResize()">

  <button (click)="onToggleFilterClick()"
          class="toggle-btn btn btn-outline-primary btn-sm d-flex d-md-none flex-row justify-content-center align-items-center">

    <mat-icon class="icon" svgIcon="sax:bold-filter"></mat-icon>

    <span class="ms-2" i18n>Фільтри</span>

    @if (activeFiltersCount; as count) {
      <span class="badge d-flex flex-row justify-content-center align-items-center ms-2">{{count}}</span>
    }

  </button>

  <form [class.d-none]="!showFilter()" class="d-none d-md-block" (ngSubmit)="onSubmit()" [formGroup]="form">

    <div class="wrapper">

      <div class="header d-flex flex-row justify-content-between align-items-center">

        <div class="title d-inline-flex flex-row align-items-center">

          <mat-icon (click)="onToggleFilterClick()" class="d-md-none me-3"
                    svgIcon="sax:outline-arrow-left-2"></mat-icon>

          <mat-icon class="icon" svgIcon="sax:bold-filter"></mat-icon>

          <span class="label" i18n>Фільтри</span>

        </div>

        @if (isFormDirty) {
          <div (click)="onClearClick()" class="clear-link">Скинути фільтри</div>
        }

      </div>

      <div class="content">

        <div class="row">

          <div class="col-12 col-sm-6 col-lg-4">

            <label for="brand" class="form-label" i18n>Бренд</label>

            <select formControlName="brand_id" id="brand" class="form-select">

              <option [selected]="isLoadingBrands() || !groupedBrands().length" value="">

                @if (isLoadingBrands()) {
                  <ng-container i18n>Завантаження…</ng-container>
                } @else {
                  <ng-container i18n>Оберіть бренд</ng-container>
                }

              </option>

              @for (group of groupedBrands(); track group.letter) {

                <optgroup [label]="group.letter">

                  @for (brand of group.brands; track brand.id) {
                    <option [value]="brand.id">{{brand.name}}</option>
                  }

                </optgroup>

              }

            </select>

          </div>

          <div class="col-12 col-sm-6 col-lg-4">

            <label for="priceFrom" class="form-label">
              <ng-container i18n>Ціна</ng-container>
              , $
            </label>

            <div class="input-group">

              <input formControlName="price_from" id="priceFrom" type="number" class="form-control"
                     placeholder="Від" i18n-placeholder />

              <input formControlName="price_to" type="number" class="form-control" placeholder="До"
                     i18n-placeholder />

            </div>

          </div>

          <div class="col-12 col-sm-6 col-lg-4">

            <label for="wheeldrive" class="form-label" i18n>Привід</label>

            <select formControlName="wheeldrive" id="wheeldrive" class="form-select">

              <option value="" i18n>Оберіть привід</option>

              @for (item of wheeldriveOptions; track item.value) {
                <option [value]="item.value">{{item.label}}</option>
              }

            </select>

          </div>

          <div class="col-12 col-sm-6 col-lg-4">

            <label for="yearFrom" class="form-label" i18n>Модельний рік</label>

            <div class="input-group">

              <input formControlName="year_from" id="yearFrom" type="number" class="form-control"
                     placeholder="Від" i18n-placeholder />

              <input formControlName="year_to" type="number" class="form-control" placeholder="До"
                     i18n-placeholder />

            </div>

          </div>

          <div class="col-12 col-sm-6 col-lg-4">

            <label for="rechargeMileage" class="form-label">
              <ng-container i18n>Запас ходу NEDC (CLTC)</ng-container>
              ,
              <ng-container i18n>км</ng-container>
            </label>

            <div class="input-group">

              <input formControlName="recharge_mileage_from" id="rechargeMileage" type="number" class="form-control"
                     placeholder="Від" i18n-placeholder />

              <input formControlName="recharge_mileage_to" type="number" class="form-control" placeholder="До"
                     i18n-placeholder />

            </div>

          </div>

          <div class="col-12 col-sm-6 col-lg-4">

            <label for="batteryCapacityFrom" class="form-label">
              <ng-container i18n>Ємність батареї</ng-container>
              ,
              <ng-container i18n>кВт/год</ng-container>
            </label>

            <div class="input-group">

              <input formControlName="battery_capacity_from" id="batteryCapacityFrom" type="number" class="form-control"
                     placeholder="Від" i18n-placeholder />

              <input formControlName="battery_capacity_to" type="number" class="form-control" placeholder="До"
                     i18n-placeholder />

            </div>

          </div>

        </div>

      </div>

      <div class="footer">

        <button class="btn btn-lg btn-primary">

          @if (!groupedBrands().length || isLoading()) {
            <evland-loader class="loader" color="white" size="26"></evland-loader>
          } @else if (totalResults() > 0) {
            <ng-container i18n>Показати {{totalResults() | plural: RESULT_PLURALS}}</ng-container>
          } @else {
            <ng-container i18n>Немає результатів</ng-container>
          }

        </button>

      </div>

    </div>

  </form>

</div>
